import { render, staticRenderFns } from "./CancelDetail.vue?vue&type=template&id=b32a67d2&scoped=true&"
import script from "./CancelDetail.vue?vue&type=script&lang=js&"
export * from "./CancelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32a67d2",
  null
  
)

export default component.exports